import * as z from 'zod'
import { useQuery } from '@tanstack/react-query'
import { useIsExternalVisitor } from '../use-user-role'
import { useRepoReplicache } from '../use-repo-replicache'

const outputSchema = z.object({
  assetsJwt: z.string(),
})

export const useProtectedFileToken = () => {
  const data = useRepoReplicache().data
  const repoId = data?.repoId
  const teamId = data?.team?.id
  const isExternalVisitor = useIsExternalVisitor()

  return useQuery(
    ['assets-token', teamId, repoId],
    async () => {
      if (!teamId || !repoId) return null

      const res = await fetch(
        `/api/ad-hoc/protected-file-auth?teamId=${teamId}&repoId=${repoId}`
      )
      if (res.status === 200) {
        const json = await res.json()
        return outputSchema.parse(json)
      } else {
        throw new Error(res.statusText)
      }
    },
    {
      enabled: Boolean(teamId && repoId && !isExternalVisitor),
      staleTime: 20 * 60 * 60 * 1000, // 20 hours
    }
  )
}
